export function resolveHostAccountId(hostInfo) {
  if (!hostInfo || typeof hostInfo !== "object") return "";

  if (typeof hostInfo._id === "string" && hostInfo._id.trim()) {
    return hostInfo._id.trim();
  }

  if (typeof hostInfo.hostId === "string" && hostInfo.hostId.trim()) {
    return hostInfo.hostId.trim();
  }

  return "";
}
